class ProductSelector extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.submitButton = this.form.querySelector('[name="add"]');
    this.cartDrawer = document.querySelector("cart-drawer");
    this.stock = this.querySelector("[data-stock]");
    this.variants = JSON.parse(
      this.querySelector("[data-variants-json]").textContent
    );
    this.variantsPrices = JSON.parse(
      this.querySelector("[data-variants-prices]").textContent
    );
    this.addEventListener("change", this.onVariantChange);
    document.addEventListener(
      "exo:add-to-cart-click",
      this.handleAddToCartClick.bind(this)
    );
  }

  handleAddToCartClick() {
    this.submitButton.click();
  }

  get priceEntry() {
    if (!this.currentVariant) return undefined;
    return this.variantsPrices.find(
      (entry) => entry.id === this.currentVariant.id
    );
  }

  onSubmitHandler(event) {
    if (!this.cartDrawer) return;

    event.preventDefault();

    this.submitButton.classList.add("disabled");

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(this.form);
    formData.append(
      "sections",
      this.cartDrawer.getSectionsToRender().map((section) => section.section)
    );
    formData.set("sections", formData.get("sections") + ",product");
    formData.append("sections_url", window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        this.cartDrawer.renderContents(response);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.submitButton.classList.remove("disabled");
      });
  }

  handleErrorMessage(errorMessage = false) {
    const errorWrapper = this.querySelector("[data-error-wrapper]");
    if (!errorWrapper) return;
    errorWrapper.classList.toggle("hidden", !errorMessage);
    errorWrapper.textContent = errorMessage || "";
  }

  onVariantChange(event) {
    if (event.target.type === "number") return;
    this.updateOptions();
    this.updateVariant();
    this.toggleAddButton(false, "");
    this.handleErrorMessage();
    this.toggleStock();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "");
      this.setUnavailable();
      return;
    }

    if (!this.currentVariant.available) {
      ``;
      this.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateURL();
    this.updateMedia();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('input[type="radio"]:checked, select'),
      (el) => el.value
    );
  }

  updateVariant() {
    this.currentVariant = this.variants.find((variant) => {
      return !variant.options
        .map((option, index) => this.options[index] === option)
        .includes(false);
    });

    const urlToFetch = new URL(window.location.href);
    urlToFetch.searchParams.set("sections", "main-product");

    fetch(urlToFetch)
      .then((response) => response.json())
      .then((responseText) => {
        document.dispatchEvent(
          new CustomEvent("update:product-media", {
            detail: { response: responseText },
          })
        );
      })
      .catch((error) => console.error(error));
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const productMedia = document.querySelector("product-media");
    // productMedia.setActiveMedia(this.currentVariant.featured_media.id);

    document.dispatchEvent(
      new CustomEvent("arvo:variant-image-update", {
        detail: { src: this.currentVariant.featured_media.preview_image.src },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has("variant") ? "set" : "append"](
      "variant",
      this.currentVariant.id
    );
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?${params.toString()}`
    );
  }

  updateVariantInput() {
    const input = this.querySelector('[name="id"]');
    input.value = this.currentVariant.id;
  }

  setUnavailable() {
    const submitButton = this.querySelector('[name="add"]');
    const price = this.querySelector(`#price-${this.dataset.sectionId}`);

    if (!submitButton) return;
    submitButton.querySelector("[data-text]").textContent =
      window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  toggleAddButton(disable, text) {
    const submitButton = this.querySelector('[name="add"]');

    if (disable) {
      submitButton.setAttribute("disabled", "disabled");
      if (text) submitButton.querySelector("[data-text]").textContent = text;
    } else {
      submitButton.removeAttribute("disabled");
      submitButton.querySelector("[data-text]").textContent =
        window.variantStrings.addToCart;
      submitButton.querySelector("[data-price]").textContent =
        this.priceEntry?.price_single || "";
    }
  }

  renderProductInfo() {
    const destinationPrice = document.querySelector(
      `#price-${this.dataset.sectionId}`
    );

    document.dispatchEvent(
      new CustomEvent("exo-price-html-update", {
        detail: { html: this.priceEntry?.price_html },
      })
    );

    destinationPrice.classList.remove("visibility-hidden");
    destinationPrice.innerHTML = this.priceEntry?.price_html || "";

    // Changes the main product image with the variant image
    if (this.priceEntry)
      document.dispatchEvent(
        new CustomEvent("exo:variant-change-update-image", {
          detail: { src: this.priceEntry.image },
        })
      );
  }

  toggleStock() {
    document.dispatchEvent(
      new CustomEvent("exo:update-availability", {
        detail: { isAvailable: this.currentVariant?.available },
      })
    );
    this.stock.classList.toggle("in-stock", this.currentVariant?.available);
    this.stock.classList.toggle("hidden", !this.currentVariant);
  }
}

customElements.define("product-selector", ProductSelector);
